import FeesInfo from './FeesInfo';

export default FeesInfo;
